<template>
  <b-card no-body class="mb-1 meal row">
      <b-btn block href="#" v-b-toggle=code variant="info" class="text-left p-2">
        {{name}}
        <span class="when-opened float-right"><font-awesome-icon icon="angle-down"/></span>
        <span class="when-closed float-right"><font-awesome-icon icon="angle-right"/></span>
      </b-btn>
    <b-collapse :id=code role="tabpanel">
      <b-card-body>
        <Category
        v-for="category in categories"
        v-bind:key="category.code"
        v-bind:code="category.code"
        v-bind:name="category.name"
        v-on:dishes:choose="onChooseDishes"
        ></Category>
      </b-card-body>
    </b-collapse>
  </b-card>
</template>

<script>
import Category from './Category'
import { CategoriesData } from '../data/data.js'

export default {
  name: 'Meal',
  components: {
    Category
  },
  props: {
    name: {
      type: String,
      required: true
    },
    code: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      categories: CategoriesData,
      chosenDishes: {}
    }
  },
  methods: {
    onChooseDishes: function (chosenDishes) {
      this.$emit('dishes:choose', {meal: this.code, chosenDishes: chosenDishes})
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Meal.vue